import React from 'react';

export default function LudiAlertBanner({ title, message, action, onAction, variant = 'info' }) {
  const styles =
    variant === 'warning'
      ? 'bg-amber-500/10 border-amber-500/40 text-amber-200'
      : 'bg-[var(--ludi-alb)] border-[var(--ludi-ald)] text-[var(--ludi-alc)]';

  return (
    <div className={`rounded-ludi-md border px-ludi-4 py-ludi-3 ${styles}`}>
      {title && <p className="text-ludi-sm font-bold mb-ludi-1">{title}</p>}
      <p className="text-ludi-sm leading-relaxed">{message}</p>
      {action && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-ludi-2 text-ludi-sm font-semibold underline text-ludi-emp"
        >
          {action}
        </button>
      )}
    </div>
  );
}
